@import 'fluid-title.theme.less';
@import '../../styles/palette.less';
@import '../../styles/mixins/fluid-icon.mixin.less';

:host {
  display: block;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /**
   * LEGACY THEME
   */
  .legacy {
    @import '../../styles/variables-iuw-legacy.less';
    @fluid-title-tokens: @fluid-title-tokens-legacy;
    @title();
  }

  /**
   * LIBERTY MUTUAL THEME
   */
  .lm {
    @import '../../styles/variables-lm.less';
    @fluid-title-tokens: @fluid-title-tokens-lm;
    @title();
  }

  /**
   * LM CORPORATE THEME
   */
  .corp {
    @import '../../styles/variables-lm-corp.less';
    @fluid-title-tokens: @fluid-title-tokens-corp;
    @title();
  }

  /**
   * PORTAL THEME
   */
  .portal {
    @import '../../styles/variables-lm-portal.less';
    @fluid-title-tokens: @fluid-title-tokens-portal;
    @title();
  }

  // ================================================================ //
  // -- Component Detached Ruleset

  @title: {
    font-family: @fluid-title-tokens[font-family];
    color: @fluid-title-tokens[color];

    &.blue { color: (@liberty-blue) }
    &.yellow { color: (@liberty-yellow-60) }
    &.orange { color: (@liberty-orange) }
    &.success { color: (@color-success) }
    &.warning { color: (@color-warning) }
    &.gray { color: (@color-text-medium) }
    &.light-gray { color: (@color-text-medium) }
    &.info { color: (@color-info) }
    &.error { color: (@color-error) }
    &.white { color: (white) }

    &.h1 {
      font-size: 32px;
      font-weight: @fluid-title-tokens[@h1][font-weight];
      letter-spacing: @fluid-title-tokens[@h1][letter-spacing];
    }

    &.h2 {
      font-size: 24px;
      font-weight: @fluid-title-tokens[@h1][font-weight];
      letter-spacing: @fluid-title-tokens[@h1][letter-spacing];
    }

    &.h3 {
      font-size: 18.72px;
      font-weight: @fluid-title-tokens[@h3][font-weight];
      letter-spacing: @fluid-title-tokens[@h3][letter-spacing];
    }

    &.h4 {
      font-size: 16px;
      font-weight: @fluid-title-tokens[@h4][font-weight];
      letter-spacing: @fluid-title-tokens[@h4][letter-spacing];
    }

    &.h5 {
      font-size: 13.28px;
      font-weight: @fluid-title-tokens[@h5][font-weight];
      letter-spacing: @fluid-title-tokens[@h5][letter-spacing];
    }

    &.h6 {
      font-size: 10.72px;
      font-weight: @fluid-title-tokens[@h6][font-weight];
      letter-spacing: @fluid-title-tokens[@h6][letter-spacing];
    }

    &.disable-gutters {
      margin: 0;
    }

    &.disable-top {
      margin-top: 0;
    }

    &.disable-bottom {
      margin-bottom: 0;
    }

  }
}
